import request from "@/utils/request";

// 获取考官课
export function getExaminerCourse(payload) {
  return request.post(`/hcp/teacherSpace/examiner-course/myCourses`, {
    ...payload
  });
}



// WEBPACK FOOTER //
// ./src/services/courseEn.js